import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';
import ViewportContext from '../../../../components/viewport/context';

import * as S from './styles';

type SotyBanner = {
  year: string;
};

const SotyBadge = ({ year }: SotyBanner) => {
  const { t, market } = useContext(AppContext);
  return (
    <S.Badge>
      <img
        src={`${market.cdn}/g/store_of_the_year/${year}/${market.code}/award/main_award.png`}
        alt={t('campaigns', 'shop-of-the-year.title-with-year', {
          year,
        })}
      />
    </S.Badge>
  );
};

const SotyContent = () => {
  const { t } = useContext(AppContext);

  return (
    <S.Content>
      <p>{t('campaigns', 'shop-of-the-year.landing-page-banner-text')}</p>
    </S.Content>
  );
};

const SotyTitle = ({ year }: SotyBanner) => {
  const { t } = useContext(AppContext);

  return (
    <h2>
      {t('campaigns', 'shop-of-the-year.landing-page-banner-title', {
        year,
      })}
    </h2>
  );
};

const SotyBannerMobile = ({ year }: SotyBanner) => {
  const { linkTo } = useContext(AppContext);
  const sotyUrl = linkTo('shopOfTheYear', {});

  return (
    <S.Banner to={sotyUrl}>
      <S.Header>
        <SotyBadge year={year} />
        <SotyTitle year={year} />
      </S.Header>
      <SotyContent />
    </S.Banner>
  );
};

const SotyBannerDesktop = ({ year }: SotyBanner) => {
  const { linkTo } = useContext(AppContext);
  const sotyUrl = linkTo('shopOfTheYear', {});

  return (
    <S.Banner to={sotyUrl}>
      <SotyBadge year={year} />
      <div>
        <S.Header>
          <SotyTitle year={year} />
        </S.Header>
        <SotyContent />
      </div>
    </S.Banner>
  );
};

const SotyBanner = ({ year }: SotyBanner) => {
  const { isMobile } = useContext(ViewportContext);

  return isMobile ? (
    <SotyBannerMobile year={year} />
  ) : (
    <SotyBannerDesktop year={year} />
  );
};

export default SotyBanner;
